import Loader from "components/Loader";
import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";
import { useState } from "react";
import { ProviderOperationsBulkToolbar } from "./ProviderOperationsBulkToolbar";
import { ProviderOperationsSearch } from "./ProviderOperationsSearch";
import { ProviderOperationsTable } from "./ProviderOperationsTable";
import { useProviderOperationsBulkAction } from "./useProviderOperationsBulkAction";
import { useProviderOperationsSearch } from "./useProviderOperationsSearch";

export function ProviderOperationsConsole() {
	const [searchQuery, setSearchQuery] = useState("");
	const [searchRunId, setSearchRunId] = useState(0);
	const searchResult = useProviderOperationsSearch(searchQuery);
	const bulkAction = useProviderOperationsBulkAction(searchResult.key);

	const handleSearch = (query: string) => {
		setSearchRunId((currentSearchRunId) => currentSearchRunId + 1);
		setSearchQuery(query);
		if (query === searchQuery) {
			searchResult.refetch();
		}
	};

	return (
		<>
			<ProviderOperationsSearch isSearching={searchResult.isFetching} onSearch={handleSearch} />
			{searchResult.isInitialLoading && <Loader />}
			{searchResult.isInitialLoading === false && searchResult.isError && (
				<p className="provider-operations-message provider-operations-message--error">
					{_("providerOperations.search.error" as keyof Keys)}
				</p>
			)}
			{searchResult.isInitialLoading === false && searchResult.data !== undefined && (
				<>
					{searchResult.data.data.rows.length > 0 && (
						<ProviderOperationsBulkToolbar
							key={searchRunId}
							rows={searchResult.data.data.rows}
							bulkAction={bulkAction}
						/>
					)}
					<ProviderOperationsTable rows={searchResult.data.data.rows} searchQueryKey={searchResult.key} />
				</>
			)}
		</>
	);
}
